module.exports = __webpack_public_path__ + "static/Theinhardt-Regular-549dfe6a9fba724781d8c89f8b48425d.woff2";